export default __webpack_public_path__ + "static/media/645.dfd41241.png";